/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Api_Keys_ManageInputs */



/**
* | output |
* | --- |
* | "Create and manage organization API keys" |
*
* @param {Plan_Gate_Benefit_Api_Keys_ManageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_api_keys_manage = /** @type {((inputs?: Plan_Gate_Benefit_Api_Keys_ManageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Api_Keys_ManageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisations-API-Schlüssel erstellen und verwalten")
	return /** @type {LocalizedString} */ ("Create and manage organization API keys")
});